import type {AuthConfig} from '@be-infinity-ltd/auth-react'

/**
 * Keycloak / OIDC cutover config for the Backoffice frontend.
 *
 * SSO_ENABLED is the single feature flag that gates the entire Keycloak-hosted
 * login path. When it is falsy (env var unset or != '1') the app renders
 * EXACTLY as it does today (legacy Metronic login), byte-for-byte.
 *
 * The shared @be-infinity-ltd/auth-react package deliberately never reads the
 * environment itself (it must stay bundler-agnostic), so the app reads its own
 * CRA env vars here and hands the package a plain AuthConfig object.
 */
export const SSO_ENABLED = process.env.REACT_APP_SSO_ENABLED === '1'

export const authConfig: AuthConfig = {
  authority: process.env.REACT_APP_OIDC_AUTHORITY as string,
  clientId: process.env.REACT_APP_OIDC_CLIENT_ID as string,
  redirectUri: process.env.REACT_APP_OIDC_REDIRECT_URI || window.location.origin + '/',
  postLogoutRedirectUri:
    process.env.REACT_APP_OIDC_REDIRECT_URI || window.location.origin + '/',
  // Keycloak issues a SESSION-BOUND refresh token for the code flow, so automaticSilentRenew refreshes
  // via the refresh token (no hidden iframe / "flashing"). Do NOT request `offline_access`: an offline
  // token SURVIVES logout by design, so the app would keep minting access tokens after the KC session
  // ends → "logout doesn't stick". A session-bound refresh token dies with the session, so
  // signoutRedirect() actually logs the user out.
  scope: 'openid profile email',
}
